import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { isToggleEnabled } from 'react-awesome-feature-toggles';
import * as actionTypes from '../constants';
import { determineSortIcon } from '../../../utils/helpers';

export const isLoading = handleActions(
  {
    [combineActions(
      actionTypes.SEARCH_RELATIONS_SUCCESS,
      actionTypes.SEARCH_RELATIONS_FAILURE,
    )]: () => false,
    [actionTypes.SEARCH_RELATIONS_REQUEST]: () => true,
  },
  false,
);

const determineWidth = (c) => {
  if (c.id.toLowerCase().includes('city') || c.id.toLowerCase().includes('postalcode')) {
    return 120;
  }
  if (
    c.id.toLowerCase() === 'equipmentcontractinfo' ||
    c.id.toLowerCase() === 'equipmentwarrantyinfo'
  ) {
    return 100;
  }
  if (c.type === 'sapId' || c.type === 'number' || c.id.toLowerCase() === 'customervatortax') {
    return 150;
  }
  return 250;
};

export const results = handleActions(
  {
    [combineActions(
      actionTypes.SEARCH_RELATIONS_REQUEST,
      actionTypes.CLEAR_SEARCH_RESULT,
    )]: () => ({}),
    [actionTypes.SEARCH_RELATIONS_SUCCESS]: (state, { payload }) => ({
      data: payload.data || [],
      showMoreItemsWarning: payload.hasMoreItems,
      columns: payload.columns
        .sort((a, b) => a.sort - b.sort)
        .filter(c => isToggleEnabled('functionalLocationSearch') ||
          !['functionallocationname', 'functionallocationnumber'].includes(c.id?.toLowerCase()),
        )
        .map((c, i) => ({
          ...c,
          index: i,
          field: c.fieldName,
          headerName: c.displayName,
          resizable: true,
          menuTabs: [],
          width: determineWidth(c),
          lockPinned: true,
          sort: c.defaultSorting?.sortDirection || null,
          sortIndex: c.defaultSorting?.sortIndex ?? null,
          hide: false,
          icons: {
            sortAscending: determineSortIcon(c.id, c.type, true),
            sortDescending: determineSortIcon(c.id, c.type, false),
          },
        })),
      header: payload.header,
    }),
  },
  {},
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SEARCH_RELATIONS_REQUEST,
      actionTypes.SEARCH_RELATIONS_SUCCESS,
    )]: () => ({}),
    [actionTypes.SEARCH_RELATIONS_FAILURE]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  isLoading,
  results,
  error,
});
